var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { injectable } from 'inversify';
/**
 * Хранит признак деградации сервиса, полученный из заголовков HTTP-ответов.
 * Признак выставляется один раз и сохраняется до перезагрузки страницы.
 */
let DegradationService = class DegradationService {
    constructor() {
        this.degraded = false;
        this.listeners = new Set();
        /**
         * Отметить сервис как деградировавший и уведомить подписчиков
         */
        this.markDegraded = () => {
            if (this.degraded) {
                return;
            }
            this.degraded = true;
            this.listeners.forEach((listener) => listener());
        };
        /**
         * Проверить, работает ли сервис в режиме деградации
         * @returns `true`, если хотя бы один ответ содержал признак деградации
         */
        this.isDegraded = () => this.degraded;
        /**
         * Подписаться на изменение признака деградации
         * @param listener - Функция, вызываемая при изменении признака
         * @returns Функция отписки
         */
        this.subscribe = (listener) => {
            this.listeners.add(listener);
            return () => {
                this.listeners.delete(listener);
            };
        };
    }
};
DegradationService = __decorate([
    injectable()
], DegradationService);
export { DegradationService };
